import { atom } from 'nanostores';

import type { SessionState } from './types.js';

export const sessionStore = atom<SessionState>({ status: 'loading', user: null });
